import { getStudentHolidaysMockHandler } from '@/features/calendar/api';
import { scheduleMockHandler } from '@/features/calendar/api/get-schedule';

export const calendarHandlers = [
  scheduleMockHandler,
  getStudentHolidaysMockHandler,
];
